export default __webpack_public_path__ + "static/ai-bfc9adb43a2fd24569406b72f0b60637.png";